// TDIC: TermsAndConditionUtils.js added
import _ from 'lodash';
import { PolicyService } from 'gw-capability-policy';
import { EmailUtil } from 'gw-portals-util-js';

const getLatestTermsAndConditionsByPortal = (termsResource) => {
    const TermsResolve = Promise.resolve(termsResource);
    return TermsResolve
        .then((data) => data.json())
        .then((tcs) => {
            const tcsArr = tcs || [];
            const filteredTcs = _.filter(tcsArr, (obj) => obj.Type === 'Portal');
            return _.slice(filteredTcs, filteredTcs.length - 1)[0];
        });
};

function saveTnCAcceptance(tcVersion, tncTransactionTypesSubTypes,
    tncTypeName, tncSubTypeName, authHeader, transactionDetail, userName, email) {
    const tncType = _.find(tncTransactionTypesSubTypes, { transaction_Type: tncTypeName });
    const tncSubType = _.find(tncType.transactionSubTypes, { transaction_SubType: tncSubTypeName });
    const reqOption = {
        Version: tcVersion,
        acceptance: 1,
        Transaction_Detail: transactionDetail,
        Transaction_Type: _.get(tncType, 'id'),
        Transaction_SubTypes: [_.get(tncSubType, 'id')],
        email_Address: EmailUtil.checkEmailValidity(email) ? email : userName
    };
    return PolicyService
        .saveUserTermsAndConditions(reqOption, authHeader)
        .then((data) => data);
}

export default {
    getLatestTermsAndConditionsByPortal, saveTnCAcceptance
};
